import { put, call, take, fork } from 'redux-saga/effects'
import { LLMUploadAttachmentService } from '../../api/llm'
import { llmUploadAttachmentSuccess } from '../../reducers/llm/action'
import { UPLOAD_CHAT_ATTACHMENT } from '../../reducers/llm/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* uploadAttachmentFlow(payload) {
  try {
    const { formData, fileName, callback } = payload

    const response = yield call(LLMUploadAttachmentService, formData)

    yield put(llmUploadAttachmentSuccess(response, fileName))
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* uploadAttachmentWatcher() {
  while (true) {
    const action = yield take(UPLOAD_CHAT_ATTACHMENT)
    const { payload } = action

    yield fork(generalSaga, uploadAttachmentFlow, payload, false)
  }
}
